const SETTINGS_ROUTE_PREFIX = '/settings';

const normalizeRoute = (value: string | null | undefined): string => {
  const trimmed = (value || '').trim();
  if (!trimmed) return '/';

  const withoutHash = trimmed.startsWith('#') ? trimmed.slice(1) : trimmed;
  return withoutHash.startsWith('/') ? withoutHash : `/${withoutHash}`;
};

export const getCurrentHashRoute = (): string => normalizeRoute(window.location.hash);

export const getHashProjectId = (): string | null => {
  const hash = window.location.hash.replace(/^#/, '');
  const queryIndex = hash.indexOf('?');
  if (queryIndex < 0) return null;

  const query = hash.slice(queryIndex + 1);
  const params = new URLSearchParams(query);
  return params.get('projectId');
};

export const buildSettingsRoute = (sourceRoute: string = getCurrentHashRoute()): string => {
  const normalizedSource = normalizeRoute(sourceRoute);
  const params = new URLSearchParams();

  if (!normalizedSource.startsWith(SETTINGS_ROUTE_PREFIX)) {
    params.set('from', normalizedSource);
  }

  const query = params.toString();
  return query ? `${SETTINGS_ROUTE_PREFIX}?${query}` : SETTINGS_ROUTE_PREFIX;
};

export const getSettingsReturnRoute = (route: string = getCurrentHashRoute()): string => {
  const normalizedRoute = normalizeRoute(route);
  if (!normalizedRoute.startsWith(SETTINGS_ROUTE_PREFIX)) {
    return normalizedRoute;
  }

  const queryIndex = normalizedRoute.indexOf('?');
  if (queryIndex < 0) {
    return '/';
  }

  const query = normalizedRoute.slice(queryIndex + 1);
  const from = normalizeRoute(new URLSearchParams(query).get('from'));
  return from.startsWith(SETTINGS_ROUTE_PREFIX) ? '/' : from;
};
